export var textColorValues = {'onLight.text.primary':'#12151A','onDark.text.primary':'#ffffff'};